import ClientNotificationInterface from '../../interfaces/client/Notification'
import notificationTypes from '../../config/notificationTypes'

export default (notifications: ClientNotificationInterface[]) =>
  notifications.filter(
    (notification: ClientNotificationInterface) =>
      notification.type === notificationTypes.warning
  )
